import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { AppScreenTitle, FormUserProfile } from "@/components/common";
import { useAddUser } from "./hooks/useAddUser";
import { ProfileContainer } from "../Profile/Profile.style";

const DEFAULT_PROFILE = {
  name: "",
  email: "",
  phoneNumber: "",
  unit: "",
  department: "",
};

const UserAddPage = () => {
  const { t: getLabel } = useTranslation();
  const { registerUser } = useAddUser();

  return (
    <Box>
      <AppScreenTitle>{getLabel("L_ADD_USER")}</AppScreenTitle>
      <ProfileContainer>
        <FormUserProfile profile={DEFAULT_PROFILE} onSubmit={registerUser} buttonPrimaryLabel={getLabel("L_ADD")} />
      </ProfileContainer>
    </Box>
  );
};

export default UserAddPage;
